module.exports = __webpack_public_path__ + "img/pro_five_8.ccb53c04.jpg";